<template>
    <div>
        <div class="grid grid-cols-12 gap-2 mb-4">
            <div class="col-span-4">
                <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                           text="Show Material Cost"
                           v-model="breakdown.materials" @input="updateData"></ui-toggle>
            </div>
            <div class="col-span-4">
                <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                           text="Show Labour Rates"
                           v-model="breakdown.labourRates" @input="updateData"></ui-toggle>
            </div>
            <div class="col-span-4">
                <ui-toggle class="p-2 rounded-xl bg-gray-100" field="text-lg text-gray-900"
                           text="Show Fixed Costs"
                           v-model="breakdown.fixedCosts" @input="updateData"></ui-toggle>
            </div>
        </div>
    </div>
</template>

<script>
import remoteStorage from "../../../../utils/remoteStorage";

export default {
    components: {},
    props: {
        breakdown: Object,
    },
    watch: {},
    data() {
        let data = remoteStorage.getItem('estimate-cost-list-toggles')
        try {
            data = data ? JSON.parse(data) : {}
        } catch (e) {
            data = {};
        }
        return {
            breakdownData: data
        }
    },
    methods: {
        updateData() {
            remoteStorage.setItem('estimate-cost-list-toggles', JSON.stringify(this.breakdown))
            this.$forceUpdate()
            this.$emit('change', this.breakdown)
        },
    },
    mounted() {
    },
}
</script>
